export const PACKAGING_TYPE_GROUPS = [
  {
    group: 'QBits (QB)',
    options: [
      { label: 'Treated (T)', value: 'qbit_treated' },
      { label: 'Untreated (U)', value: 'qbit_untreated' }
    ]
  },
  {
    group: 'TO',
    options: [
      { label: 'Treated (T)', value: 'to_treated' },
      { label: 'Untreated (U)', value: 'to_untreated' }
    ]
  },
  {
    group: 'Paper Bag (PB)',
    options: [
      { label: 'Treated (T)', value: 'pb_treated' },
      { label: 'Untreated (U)', value: 'pb_untreated' }
    ]
  }
] as const;

export type PackagingTypeValue =
  (typeof PACKAGING_TYPE_GROUPS)[number]['options'][number]['value'];
